import React from 'react';
import {date_format, date_time_format} from '../utils/constants';
import moment from 'moment';

export default function DateDisplay(props) {
    let format = props.time
        ? date_time_format
        : date_format;
    return (
        <span>{moment(props.date).format(format)}</span>
    );
}



// WEBPACK FOOTER //
// ./src/js/components/date-display.jsx